/** Tamaño máximo (px) de miniatura solo para pantalla — no afecta al archivo que sube Marco. */
export const FOTO_THUMB_MAX_PX = 240;
const FOTO_THUMB_JPEG_QUALITY = 0.82;

function cargarBitmap(fileOrBlob) {
  if (typeof createImageBitmap === "function") {
    return createImageBitmap(fileOrBlob, { resizeWidth: FOTO_THUMB_MAX_PX, resizeHeight: FOTO_THUMB_MAX_PX });
  }
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(fileOrBlob);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("imagen_no_cargada"));
    };
    img.src = url;
  });
}

function dibujarMiniatura(source, maxPx) {
  const w = source.width || source.naturalWidth;
  const h = source.height || source.naturalHeight;
  if (!w || !h) throw new Error("sin_dimensiones");
  const scale = Math.min(1, maxPx / Math.max(w, h));
  const tw = Math.max(1, Math.round(w * scale));
  const th = Math.max(1, Math.round(h * scale));
  const canvas = document.createElement("canvas");
  canvas.width = tw;
  canvas.height = th;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("sin_canvas");
  ctx.drawImage(source, 0, 0, tw, th);
  return canvas;
}

/** Genera blob URL JPEG ligero para el grid (el File original no se modifica). */
export async function crearMiniaturaDesdeFile(file, maxPx = FOTO_THUMB_MAX_PX) {
  if (!(file instanceof Blob)) throw new Error("no_es_blob");
  const source = await cargarBitmap(file);
  const canvas = dibujarMiniatura(source, maxPx);
  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error("toBlob_fallo"))),
      "image/jpeg",
      FOTO_THUMB_JPEG_QUALITY,
    );
  });
  return URL.createObjectURL(blob);
}

export function revocarMiniaturaUrl(url) {
  if (url && String(url).startsWith("blob:")) {
    try {
      URL.revokeObjectURL(url);
    } catch {
      /* ignore */
    }
  }
}
